import styled, { css } from 'styled-components';

import { FloorGameTierLabel } from '@pkg/types/floorGame';

export const Wrapper = styled.div<{ $floorPriceTier: FloorGameTierLabel | '' }>`
    width: 100%;
    height: 60px;

    background: linear-gradient(90deg, #2d2b3d 0%, #151327 100%);

    border-radius: 8px;

    display: flex;
    align-items: center;
    justify-content: space-between;

    padding: 8px;
    cursor: pointer;

    transition: box-shadow 200ms ease;

    @media (min-width: ${({ theme }) => theme.breakpoints.mobile}) {
        height: 80px;
        border-radius: 10px;
        padding: 10px;
    }

    ${({ $floorPriceTier }) => {
        switch ($floorPriceTier) {
            // #ffbd41
            case FloorGameTierLabel.Tier1:
            case FloorGameTierLabel.Tier2:
                return css`
                    background: linear-gradient(188deg, #323232 1.49%, #131d78a1 37.77%, #242424 94.32%);
                `;

            case FloorGameTierLabel.Tier3:
                return css`
                    background: linear-gradient(188deg, #323232 1.49%, #411b68 37.77%, #242424 94.32%);
                `;

            case FloorGameTierLabel.Tier4:
                return css`
                    background: linear-gradient(188deg, #323232 1.49%, #ffbc22a1 37.77%, #242424 94.32%);
                `;
        }
    }}

    &:hover {
        box-shadow:
            0 0 68px 0 rgba(255, 255, 255, 0.1) inset,
            0 0 0 1px rgba(255, 255, 255, 0.1) inset;
    }
`;

export const LeftSide = styled.div`
    display: flex;
    align-items: center;
    gap: 15px;

    @media (min-width: ${({ theme }) => theme.breakpoints.mobile}) {
        gap: 20px;
    }
`;

export const Image = styled.div<{ $image: string; $isFloorPrice?: boolean }>`
    width: 42px;
    height: 42px;
    border-radius: 4px;
    background-color: #000;

    ${({ $image }) => css`
        background-image: url(${$image});
        background-size: cover;
        background-position: center center;
    `};

    ${({ $isFloorPrice }) =>
        $isFloorPrice &&
        css`
            border-radius: 50%;
        `};

    @media (min-width: ${({ theme }) => theme.breakpoints.mobile}) {
        width: 60px;
        height: 60px;
        border-radius: 5px;
        ${({ $isFloorPrice }) =>
            $isFloorPrice &&
            css`
                border-radius: 50%;
            `};
    }
`;

export const Info = styled.div`
    display: flex;
    flex-direction: column;
    gap: 5px;
`;

export const Name = styled.div`
    font-family: 'Alliance No.1';
    font-style: normal;
    font-weight: 700;
    font-size: 12px;
    line-height: 130%;
    letter-spacing: -0.02em;
    color: #ffffff;

    max-width: 160px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;

    @media (min-width: ${({ theme }) => theme.breakpoints.mobile}) {
        font-size: 14px;
    }
`;

export const YatRow = styled.div`
    display: flex;
    align-items: center;
    gap: 5px;
`;

export const Date = styled.div`
    font-family: 'Alliance No.1';
    font-style: normal;
    font-weight: 500;
    font-size: 10px;
    line-height: 100%;
    letter-spacing: -0.02em;

    color: rgba(255, 255, 255, 0.5);

    @media (min-width: ${({ theme }) => theme.breakpoints.mobile}) {
        font-size: 12px;
    }
`;

export const RightSide = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    gap: 5px;

    @media (min-width: ${({ theme }) => theme.breakpoints.mobile}) {
        gap: 7px;
    }
`;

export const Value = styled.div`
    font-family: 'Alliance No.1';
    font-weight: 700;
    font-size: 12px;
    line-height: 120%;
    color: #ffffff;

    display: flex;
    align-items: center;
    gap: 7px;

    padding-right: 4px;

    svg {
        width: 7px;
    }

    @media (min-width: ${({ theme }) => theme.breakpoints.mobile}) {
        font-size: 16px;

        svg {
            width: 11px;
        }
    }
`;
export const Ellipsis = styled.span`
    &&& {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        text-indent: 0.5625rem;
        margin-left: -0.5625rem;
    }
`;

export const WalletWrapper = styled.div`
    display: flex;
    max-width: 100px;
    font-size: 12px;
`;

export const FloorLabel = styled.span`
    text-transform: uppercase;
    color: #ffe3e3;
    font-weight: 700;
    font-size: 16px;
`;

export const FloorValue = styled.span`
    font-family: 'Tusker Grotesk';
    font-style: normal;
    font-weight: 700;
    font-size: 17px;
    line-height: 100%;
`;

export const FloorWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    gap: 5px;
    opacity: 0.8;
`;

export const FloorContainer = styled.div`
    display: flex;
    gap: 15px;
    svg {
        width: 25px;
    }
`;
